// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { isMobileScreen, isTabletScreen } from "@stoneage/XDL/Utilities";
import { FC, useEffect } from "react";
import { CustomAppState } from "@stoneage/App/Store/Reducers";
import { connect, ResolveThunks } from "react-redux";
import { getSettingsCollection } from "@stoneage/App/Store/Selectors/SettingsSelectors";
import { constants } from "@stoneage/XDL/constants";
import { xCommonUpdate } from "@stoneage/App/Handlers/XNG/Common";

const mapStateToProps = (state: CustomAppState) => {
    const customSettings = getSettingsCollection(state).customSettings;
    return {
        defaultImages: {
            cloudinaryMediaRootPath: customSettings.cloudinaryMediaRootPath,
            productSmallDefaultImagePath: customSettings.productSmallDefaultImagePath,
            productMediumDefaultImagePath: customSettings.productMediumDefaultImagePath,
            productLargeDefaultImagePath: customSettings.productLargeDefaultImagePath,
            cloudinaryGlobalNotFoundImagePath: customSettings.cloudinaryGlobalNotFoundImagePath,
        },
    };
};

const mapDispatchToProps = {
    xCommonUpdate,
};

type Props = ReturnType<typeof mapStateToProps> & ResolveThunks<typeof mapDispatchToProps>;

const XngUtilities: FC<Props> = ({ defaultImages, xCommonUpdate }) => {
    useEffect(() => {
        if (typeof localStorage !== "undefined") {
            localStorage.setItem(constants.cookies.cloudinaryMediaRootPath, defaultImages.cloudinaryMediaRootPath);
            localStorage.setItem(
                constants.cookies.productSmallDefaultImagePath,
                defaultImages.productSmallDefaultImagePath,
            );
            localStorage.setItem(
                constants.cookies.productMediumDefaultImagePath,
                defaultImages.productMediumDefaultImagePath,
            );
            localStorage.setItem(
                constants.cookies.productLargeDefaultImagePath,
                defaultImages.productLargeDefaultImagePath,
            );
            localStorage.setItem(
                constants.cookies.cloudinaryGlobalNotFoundImagePath,
                defaultImages.cloudinaryGlobalNotFoundImagePath,
            );
        }
    }, [defaultImages]);

    const handleResize = () => {
        const isMobileScreenValue = isMobileScreen();
        const isTabletScreenValue = isTabletScreen();
        xCommonUpdate({ key: "isMobileScreen", value: isMobileScreenValue });
        xCommonUpdate({ key: "isTabletScreen", value: isTabletScreenValue });
    };

    useEffect(() => {
        window.addEventListener("resize", handleResize, { passive: true });
        handleResize();

        return () => {
            window.removeEventListener("resize", handleResize);
        };
    }, []);

    return null;
};

export default connect(mapStateToProps, mapDispatchToProps)(XngUtilities);
